<template>
  <a-card
    :loading="loading"
    :bordered="false"
    :bodyStyle="{ padding: '0px', width: '100%' }"
  >
    <a-list size="large">
      <div v-if="showLoadingMore" slot="loadMore" class="loadingbtn">
        <a-spin v-if="loadingMore" />
        <a-button
          v-else
          @click="onLoadMore"
          type="primary"
          class="fontsize20 newslistbutton"
        >
          加载更多
        </a-button>
      </div>
      <a-list-item :key="index" v-for="(item, index) in activities">
        <a-row :gutter="[0, 0]">
          <a-col :xl="7" :lg="7" :md="7" :sm="24" :xs="24">
            <div class="news-avatar">
              <a @click="openNewHtml(item.id)">
                <img
                  :src="
                    item.cover && item.cover.url ? item.cover.url : '/public/次新闻3.png'
                  "
              /></a>
            </div>
          </a-col>
          <a-col :xl="17" :lg="17" :md="17" :sm="24" :xs="24">
            <div class="newslist-right">
              <!-- <div class="news-sub-title fontsize16">{{ item.subTitle }}</div> -->
              <a-skeleton :loading="loading" active avatar>
                <a-list-item-meta>
                  <a @click="openNewHtml(item.id)"
                    slot="title"
                    class="fontsize26 news-title"
                    :title="item.title"
                    >{{ item.title }}
                  </a>
                  <a @click="openNewHtml(item.id)" slot="description"
                    ><p>{{ item.digest }}</p>
                  </a>
                </a-list-item-meta>
              </a-skeleton>
              <news-tags
                :tags="item.tags"
                :publishTime="item.time ? moment(item.time).format('YYYY-MM-DD') : ''"
                :classification="classification"
              >
                <span slot="title"
                  >{{ item.classificationName }}
                  <a-divider v-show="item.tags.length" type="vertical"
                /></span>
              </news-tags>
            </div>
          </a-col>
        </a-row>
      </a-list-item>
    </a-list>
  </a-card>
</template>

<script>
import { listContent } from "@/api/app-crm.js";
import NewsTags from "./NewsTags.vue";
import moment from "moment";
import UserActiveLog from "@/utils/userActiveLog";

export default {
  // searchType: 关键词搜索 keywords, 标签搜索 selectedTag, 默认 default
  props: ["classification", "keywords", "selectedTag", "searchType"],
  components: {
    NewsTags,
  },
  data() {
    return {
      // timeFix: timeFix(),
      // avatar: '',
      // user: {},
      // projects: [],
      moment,
      loading: true,
      activities: [],
      // loading: true,
      loadingMore: false,
      showLoadingMore: true,
      data: [],
      actions: [
        { type: "star-o", text: "156" },
        { type: "like-o", text: "156" },
        { type: "message", text: "2" },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
      },
      totalPages: 0,
    };
  },
  mounted() {
    // this.searchType = "default";
    this.dataInit();
    console.log("child mounted");
    // setTimeout(() => {
    //   console.log("child setTimeout ");
    //   if (!this.keywords && !this.selectedTag) {
    //     this.getData({}, (res) => {
    //       this.loading = false;
    //       // this.data = res.results;
    //     });
    //   }
    // }, 20);
  },

  watch: {
    // watch 监听 props 中的值
    keywords(newVal, oldVal) {
      console.log("keywords", newVal);
      // if (newVal) {
      // this.searchType = "keywords";
      this.dataInit();
      // 关键词搜索的时候，是在全部资讯中搜索，不管当前所处的栏目
      this.getData({ keywords: newVal, classification: "" }, () => {});
      // }
    },
    selectedTag(newVal, oldVal) {
      console.log("selectedTag", newVal);
      // this.searchType = "selectedTag";
      this.dataInit();
      if (newVal) {
        // 标签搜索的时候，是当前栏目中筛选
        this.getData({ tags: [newVal] }, () => {});
      } else {
        this.getData({}, () => {});
      }
    },

    searchType(newVal, oldVal) {
      // console.log("keywords", newVal);
      // if (newVal) {
      // this.searchType = "keywords";
      this.dataInit();
      console.log(newVal, "---------searchType----------");
      if (newVal === "keywords" && newVal !== oldVal) {
        // 关键词搜索的时候，是在全部资讯中搜索，不管当前所处的栏目
        // this.getData({ keywords: this.keywords, classification: "" }, () => {});
      } else if (newVal === "selectedTag" && newVal !== oldVal) {
        // 标签搜索的时候，是当前栏目中筛选
        // this.getData({ tags: [this.selectedTag] }, () => {});
      } else {
        this.getData({}, () => {});
      }

      // }
    },
  },

  methods: {
    openNewHtml(id) {
      const userLog = Object.create(UserActiveLog);
      userLog.openNewHtml(id);
    },
    dataInit() {
      this.pagination = {
        current: 1,
        pageSize: 10,
      };
      this.activities = [];
      this.loading = true;
      this.loadingMore = false;
      this.showLoadingMore = true;
    },
    onSearch(value) {
      console.log(value);
    },
    getData(params, callback) {
      let param = {
        classification: this.classification || "",
        ...params,
        pages: {
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize,
        },
      };

      listContent(param).then((data) => {
        // if (data.code === 3007001) {
        //   this.errorMsgStatus = true;
        //   this.modalTitle = "搜索提示";
        //   return;
        // }
        let sourceData = data.data && data.data.list ? data.data.list : [];
        const pags = data.data && data.data.pages ? data.data.pages : {};
        const pagination = { ...this.pagination };
        this.showLoadingMore = pags.totalPages > pagination.current;
        pagination.current = pagination.current + 1;
        console.log("===pagination", pagination);
        this.pagination = pagination;
        this.activities = this.activities.concat(sourceData);
        // this.pagination = pagination;
        this.loading = false;
        callback && callback();
      });
    },
    onLoadMore() {
      this.loadingMore = true;
      console.log("this.pagination", this.pagination);
      let params = {};
      if (this.selectedTag) {
        params = {
          tags: [this.selectedTag],
        };
      }

      if (this.searchType === "keywords") {
        params = {
          keywords: this.keywords,
          classification: "",
        };
      }

      this.getData(params, (res) => {
        // this.data = this.data.concat(res.results);
        console.log("this.loadingMore", "-------res---------");
        this.loadingMore = false;
        this.$nextTick(() => {
          window.dispatchEvent(new Event("resize"));
        });
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.loadingbtn{
  min-height:130px;
  text-align:center;
  .ant-spin-spinning{
    padding-top:40px;
  }
}
.newslistbutton{
  width: 200px;
  height: 64px;
  background:#198BFF;
  border-radius: 6px;
  font-family: 'Alibaba-PuHuiTi-R';
  margin: 45px auto 60px;
  font-family: "Alibaba-PuHuiTi-R";
  display: block;
  &:hover{
    background:#006ddd
  }
}

.news-title{
  width: 100%;
  // width: 600px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.newslist-right{
  width: 100%;
  padding-left:48px;
}
.ant-list-item-meta{
  height: 150px;
  position: relative;
}

  ::v-deep .ant-list-item-meta-content{
    width: 100%;
  }

.ant-list-item-meta-description{
  font-size:18px;
  color:#333;
  line-height: 30px;
  font-family: 'Alibaba-PuHuiTi-R';
  margin-bottom: 0px;
  padding-top:0px;
  height: 60px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  a:hover{
    color:#333;
  }
}
.ant-list-item .news-avatar{
  overflow: hidden
}
::v-deep  .ant-list-item .news-avatar img {
    -moz-transition: -moz-transform 1.2s;
    -o-transition: -o-transform 1.2s;
    -webkit-transition: -webkit-transform 1.2s;
    transition: transform 1.2s;
    width:100%
}
::v-deep .ant-list-item:hover .news-avatar img{
  -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
.ant-list-item:hover .ant-list-item-meta-title  a{
  color: #2B68FF;
}
.ant-list-item-meta-title a{
  color: #333;
  display: inline-block;
  overflow: hidden
}
.ant-list-lg .ant-list-item{
  padding:20px 0px;
}
.news-avatar img{
  height:180px;
}
.ant-list-split .ant-list-item{
  border-bottom:none;
}
.news-avatar{
    width: 100%;
    > img {
      width: 100%;
    }
  }

  .news-content{
    width: 100%;
    height: 100%;

  }

  ::v-deep .ant-card-head{
    border-radius: 4px;
    border-top: 8px solid #1b88fe;
  }

  ::v-deep .ant-row{
    width: 100%;
  }

  ::v-deep .ant-list-item-meta-title{
    font-size: 26px;
    font-family: AlibabaPuHuiTiM;
    font-weight: normal;
    color: #333646;
    line-height: 36px;
  }

  ::v-deep .ant-list-item{
    padding-top: 0px !important;
    padding-bottom: 40px !important;
  }
</style>
